const ProductIcons = {
  BusinessIcon: <i className="colour-primary fak fa-id-business-icon fa-2x"></i>,
  HomeIcon: <i className="colour-primary fak fa-id-house-icon fa-2x"></i>,
}

export default ProductIcons
